<script lang="ts" setup>
import { useI18n } from "vue-i18n";

const { t } = useI18n();

defineProps<{
  dispatchConfirmed: boolean;
}>();

defineModel<boolean>("showReplaceTruckDialog", { default: false });
defineModel<boolean>("showRateConfirmationDialog", { default: false });

const emits = defineEmits<{
  (e: "update:showReplaceTruckDialog", value: boolean): void;
  (e: "update:showRateConfirmationDialog", value: boolean): void;
}>();
</script>

<template>
  <v-menu>
    <template #activator="{ props: menuProps }">
      <v-btn elevation="0" icon="mdi-dots-horizontal" size="x-small" v-bind="menuProps" />
    </template>

    <v-list>
      <v-tooltip :disabled="!dispatchConfirmed" location="top left">
        <template #activator="{ props: tooltipProps }">
          <div v-bind="tooltipProps">
            <v-list-item :disabled="dispatchConfirmed" @click="emits('update:showReplaceTruckDialog', true)">
              <v-list-item-title>{{ t("trucks.replace-truck") }}</v-list-item-title>
            </v-list-item>
          </div>
        </template>

        {{ t("trucks.replace-truck-disabled") }}
      </v-tooltip>

      <v-list-item @click="emits('update:showRateConfirmationDialog', true)">
        <v-list-item-title>{{ t("trip.generate-rate-confirmation") }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<style lang="scss" scoped></style>
